import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import "@marekl/adminer/styles";
import "dayjs/locale/cs";
import { setupDayjs } from "@marekl/adminer/datetime";
import { configureNotify } from "@marekl/adminer/api";
import { resolveTranslator } from "@marekl/adminer/util";
import csDict from "@marekl/adminer/i18n/cs";
import { queryClient } from "./lib/queryClient";
import { ErrorBoundary } from "@marekl/adminer/components";
import App from "./App";
import "./index.css";

// Only the timezone: `csDict` is a full locale bundle, so the
// `<AdminerProvider i18n={csDict}>` in App.tsx applies its formats (and the
// Czech dayjs locale) itself. Calling configureFormatting here as well would
// be a second, hand-copied Czech source that can drift from the first — and
// it is how `calendarFormats` went missing, which dayjs does NOT ship with
// its `cs` locale and without which `formatCalendar` falls back to English
// wording and US date order.
setupDayjs({ timezone: "Europe/Prague", locale: "cs" });
// Not provider-applied: toasts are fired from event handlers, outside any
// React subtree the provider could reach.
configureNotify({ t: resolveTranslator(csDict) });

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        {/* AdminerProvider lives inside the router (see App.tsx): its
            LinkComponent renders <Link>, which needs router context. */}
        <App />
      </QueryClientProvider>
    </ErrorBoundary>
  </React.StrictMode>,
);
